const { default: en } = require("./langauges/en");
const { default: fr } = require("./langauges/fr");

const language = {
    en : en,
    fr : fr
}

export default language